import React from "react";
import { Header, Text } from "@fluentui/react-northstar";
import { Modal } from "ecom-teams-apps-core";
import styles from "./errorModal.module.scss";

interface ErrorModalProps {
    header: string;
    message: string;
}

const ErrorModal: React.FC<ErrorModalProps> = (props: ErrorModalProps) => {
    return (
        <Modal isOpen withOverlay>
            <div className={styles.modalWrapper}>
                <Header as="h1" content={props.header} />
                <Text size="large" content={props.message}></Text>
            </div>
        </Modal>
    );
};

export default ErrorModal;
